export default "__VITE_ASSET__CVaFd3Mz__"